import { useEffect, useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";
import { Bounce, toast } from "react-toastify";

const AddTipologiaTitolo = () => {
  const [loading, setLoading] = useState(false);
  const [titoloTipologia, setTitoloTipologia] = useState("");
  const [descrizioneTitolo, setDescrizioneTitolo] = useState("");
  const [livelloTitoloDiStudio, setlLivelloTitoloDiStudio] = useState("");
  const [errors, setErrors] = useState("");
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);

  const isValid = () => {
    const inputErrors = {};
    if (titoloTipologia.trim() === "") {
      inputErrors.titoloTipologia =
        "Il campo Tipologia Titolo non può essere vuoto!";
    }

    if (descrizioneTitolo.trim() === "") {
      inputErrors.descrizioneTitolo =
        "Il campo Descrizione Titolo non può essere vuoto!";
    }

    if (livelloTitoloDiStudio.trim() === "") {
      inputErrors.livelloTitoloDiStudio =
        "Il campo Livello Titolo di Studio non può essere vuoto!";
    }

    setErrors(inputErrors);
    return Object.keys(inputErrors).length === 0;
  };

  const addTipTitolo = async () => {
    if (!isValid()) return;

    try {
      setLoading(true);
      const response = await api.post("/tipologia-titoli", {
        titoloTipologia,
        descrizioneTitolo,
        livelloTitoloDiStudio,
      });

      if (response.status === 200 || response.data?.status === 200) {
        toast.success("Tipologia Titolo aggiunta con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        navigate("/tipologia-titolo");
      } else {
        toast.error("Qualcosa è andato storto!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "ADMIN") {
      alert(
        "Accedi come amministratore per aggiungere la tipologia di titolo!"
      );

      navigate("/login");
      localStorage.clear();
    } else {
      setIsAuthorized(true);
    }
  }, [navigate]);

  if (!isAuthorized) return null;

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">Aggiungi Tipologia Titolo</div>
        <div className="header-actions">
          <button
            onClick={() => navigate("/tipologia-titolo")}
            className="back-btn"
          >
            <i className="fa-solid fa-arrow-left"></i>
            Torna alle Tipologie
          </button>
        </div>
      </div>

      <div className="page-content add-tipologia-container">
        <div className="add-tipologia-card">
          <div className="card-header">
            <div className="card-title">
              <i className="fa-solid fa-graduation-cap"></i>
              Nuova Tipologia Titolo
            </div>
          </div>

          <div className="card-content">
            <div className="form-grid">
              <div className="form-field">
                <label className="field-label">
                  <i className="fa-solid fa-certificate"></i>
                  Tipologia Titolo
                </label>
                <div className="field-input">
                  <input
                    type="text"
                    value={titoloTipologia}
                    onChange={(e) => {
                      setTitoloTipologia(e.target.value);
                      if (errors.titoloTipologia) {
                        setErrors((prev) => ({ ...prev, titoloTipologia: "" }));
                      }
                    }}
                    placeholder="Inserisci la tipologia titolo"
                    className={errors.titoloTipologia ? "error-input" : ""}
                  />
                  {errors.titoloTipologia && (
                    <div className="error-message">
                      {errors.titoloTipologia}
                    </div>
                  )}
                </div>
              </div>

              <div className="form-field">
                <label className="field-label">
                  <i className="fa-solid fa-layer-group"></i>
                  Livello Titolo di Studio
                </label>
                <div className="field-input">
                  <input
                    type="text"
                    value={livelloTitoloDiStudio}
                    onChange={(e) => {
                      setlLivelloTitoloDiStudio(e.target.value);
                      if (errors.livelloTitoloDiStudio) {
                        setErrors((prev) => ({
                          ...prev,
                          livelloTitoloDiStudio: "",
                        }));
                      }
                    }}
                    placeholder="Inserisci il livello titolo di studio"
                    className={
                      errors.livelloTitoloDiStudio ? "error-input" : ""
                    }
                  />
                  {errors.livelloTitoloDiStudio && (
                    <div className="error-message">
                      {errors.livelloTitoloDiStudio}
                    </div>
                  )}
                </div>
              </div>

              <div className="form-field full-width">
                <label className="field-label">
                  <i className="fa-solid fa-align-left"></i>
                  Descrizione Titolo
                </label>
                <div className="field-input">
                  <textarea
                    value={descrizioneTitolo}
                    onChange={(e) => {
                      setDescrizioneTitolo(e.target.value);
                      if (errors.descrizioneTitolo) {
                        setErrors((prev) => ({
                          ...prev,
                          descrizioneTitolo: "",
                        }));
                      }
                    }}
                    rows={4}
                    placeholder="Inserisci la descrizione del titolo"
                    className={errors.descrizioneTitolo ? "error-input" : ""}
                  />
                  {errors.descrizioneTitolo && (
                    <div className="error-message">
                      {errors.descrizioneTitolo}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="action-buttons">
              <button
                className="cancel-btn"
                onClick={() => navigate("/tipologia-titolo")}
              >
                <i className="fa-solid fa-times"></i>
                Annulla
              </button>
              <button className="save-btn" onClick={addTipTitolo}>
                <i className="fa-solid fa-plus"></i>
                Aggiungi Tipologia
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTipologiaTitolo;
